import { Redirect, Route, Switch } from 'react-router-dom';
import { getConfig } from '../../util/configUtil';
import { TreatmentsBoard } from '../../pages/insight/lite/treatmentsBoard';
import { LiveDashboard } from '../../pages/insight/lite/liveDashboard';
import { EWTDashboard } from '../../pages/insight/lite/ewtDashboard';

function DashboardRoutes({ match }) {
    const insightDashboard = getConfig('modules.insightDashboard', {});
    const isBoardsEnabled = insightDashboard.treatmentBoard;
    const isLiveDashboardEnabled = insightDashboard.liveDashboard;
    const isEwtDashboardEnabled = insightDashboard.ewtDashboard;

    return (
        <Switch>
            {isLiveDashboardEnabled && (
                <Route path={`${match.path}/live-dashboard`}>
                    <LiveDashboard />
                </Route>
            )}
            {isLiveDashboardEnabled && (
                <Route path={`${match.path}/live-dashboard-management`}>
                    <LiveDashboard isAdminMode />
                </Route>
            )}
            {isBoardsEnabled && <Route exact path={`${match.path}/boards`} component={TreatmentsBoard} />}
            {isBoardsEnabled && (
                <Route exact path={`${match.path}/management-boards`}>
                    <TreatmentsBoard isAdminMode />
                </Route>
            )}
            {isEwtDashboardEnabled && (
                <Route exact path={`${match.path}/ewt-board`}>
                    <EWTDashboard />
                </Route>
            )}
            {isEwtDashboardEnabled && (
                <Route exact path={`${match.path}/ewt-board-admin`}>
                    <EWTDashboard isAdminMode />
                </Route>
            )}
            <Redirect to={match.path} />
        </Switch>
    );
}

export default DashboardRoutes;
